import angular from 'angular';
import { ManageAccountSettingsContainerComponent } from './manage-account-settings-container.component';

export const AccountManagementModule = angular
    .module("apex.mainApp.account.management", [])
    .component("apexManageAccountSettingsContainer", ManageAccountSettingsContainerComponent)
    .name;
